module.exports = __webpack_public_path__ + "img/Apoint1.5101fadf.png";